import { getProductById, getProductsByCategory, productData } from '../components/products/productData';

const HOME_CARD_PHOTOS = [
  '/card_photos/vertical_blind.jpg',
  '/card_photos/aluminum_blind.jpg',
  '/card_photos/wood_blind.jpg',
  '/card_photos/faux_blind.jpg',
  '/card_photos/plantation_shutter.jpg',
  '/card_photos/eclipse_shutter.jpg',
];

const HOME_HERO_PHOTOS = [
  '/hero_1.jpg',
  '/hero_2.jpg',
  '/hero_3.jpg',
];

const HOME_SECTION_PHOTOS = [
  '/aboutus_img.jpg',
  '/foot_back.jpg',
];

const CATEGORY_ROUTES = {
  '/blinds': 'BLINDS',
  '/shutters': 'SHUTTERS',
  '/shades': 'SHADES',
};

// First ~3 rows of the 5-column swatch grid — enough for a clean first paint.
const INITIAL_SWATCH_PRELOAD_COUNT = 15;

function uniqueUrls(urls) {
  return [...new Set(urls.filter(Boolean))];
}

function productHeroImages(products) {
  return products.map((product) => product.images?.[0]).filter(Boolean);
}

function collectProductSupplementaryImages(product) {
  const urls = [];

  if (product.tiltOptionsImage?.imageUrl) {
    urls.push(product.tiltOptionsImage.imageUrl);
  }

  if (product.specialityOptionsImage?.imageUrl) {
    urls.push(product.specialityOptionsImage.imageUrl);
  }

  if (product.motorizationImage?.imageUrl) {
    urls.push(product.motorizationImage.imageUrl);
  }

  if (product.specialityShapes?.imageUrl) {
    urls.push(product.specialityShapes.imageUrl);
  }

  product.operatingSystems?.forEach((system) => {
    if (system?.imageUrl) {
      urls.push(system.imageUrl);
    }
  });

  return uniqueUrls(urls);
}

function collectProductPageImageSets(product) {
  if (!product) {
    return { blocking: [], background: [] };
  }

  const swatchUrls = uniqueUrls(
    product.swatches?.map((swatch) => swatch?.imageUrl) ?? [],
  );

  const blocking = uniqueUrls([
    product.images?.[0],
    ...collectProductSupplementaryImages(product),
    ...swatchUrls.slice(0, INITIAL_SWATCH_PRELOAD_COUNT),
  ]);

  const background = swatchUrls.slice(INITIAL_SWATCH_PRELOAD_COUNT);

  return { blocking, background };
}

function collectProductPageImages(product) {
  const { blocking, background } = collectProductPageImageSets(product);
  return uniqueUrls([...blocking, ...background]);
}

function getCriticalImageUrls(pathname) {
  return getPageLoadConfig(pathname).urls;
}

function getPageLoadConfig(pathname) {
  if (pathname === '/') {
    return {
      urls: uniqueUrls([
        ...HOME_HERO_PHOTOS,
        ...HOME_CARD_PHOTOS,
        ...HOME_SECTION_PHOTOS,
      ]),
      backgroundUrls: [],
      minDuration: 1450,
      maxDuration: 8000,
    };
  }

  if (pathname === '/products') {
    return {
      urls: productHeroImages(Object.values(productData)),
      backgroundUrls: [],
      minDuration: 780,
      maxDuration: 8000,
    };
  }

  if (CATEGORY_ROUTES[pathname]) {
    return {
      urls: productHeroImages(getProductsByCategory(CATEGORY_ROUTES[pathname])),
      backgroundUrls: [],
      minDuration: 780,
      maxDuration: 8000,
    };
  }

  if (pathname.startsWith('/product/')) {
    const productId = pathname.split('/')[2];
    const product = getProductById(productId);
    const { blocking, background } = collectProductPageImageSets(product);

    return {
      urls: blocking,
      backgroundUrls: background,
      minDuration: 650,
      maxDuration: 4500,
    };
  }

  return {
    urls: [],
    backgroundUrls: [],
    minDuration: 650,
    maxDuration: 3500,
  };
}

export {
  INITIAL_SWATCH_PRELOAD_COUNT,
  collectProductPageImages,
  collectProductPageImageSets,
  getCriticalImageUrls,
  getPageLoadConfig,
};
